import { Chart, ChartFooterChard, Typography, colors, IconGraphy } from '@leapeasy/ui-kit';
import { Box } from '@mui/material';

export const CoverageChart = ({ data, onClickItem }) => {
  const RGCoverage = Number(data?.RGCoverage || 0);
  const LDRCoverage = Number(data?.LDRCoverage || 0);
  const totalCoverage = RGCoverage + LDRCoverage;
  const handleRentGuarantyClick = onClickItem
    ? () => onClickItem('coverage_rent_guaranty')
    : undefined;
  const handleLdrClick = onClickItem ? () => onClickItem('coverage_ldr') : undefined;
  const handleTotalCoverageClick = onClickItem ? () => onClickItem('coverage_total') : undefined;

  return (
    <Chart
      variant="pie"
      pieMinAngle={30}
      data={[
        {
          name: 'Rent Guaranty',
          value: totalCoverage ? (RGCoverage / totalCoverage) * 100 : 0,
        },
        {
          name: 'LDR Commercial',
          value: totalCoverage ? (LDRCoverage / totalCoverage) * 100 : 0,
        },
      ]}
      colors={[colors.parisGreen[100], colors.parisGreen[50]]}
      bodyStyles={{
        background: '#ECF9F4',
      }}
      title="Coverage"
      description="Here is an overview of coverage types and their respective proportions."
      icon={<IconGraphy icon="FileFolder.TextSnippet" />}
      footer={
        <Box
          sx={{
            gap: '16px',
            width: '100%',
            display: 'flex',
            '& > *': { flexGrow: 1 },
          }}
        >
          <ChartFooterChard
            backgroundColor="#F9F8F9"
            activeColor={colors.parisGreen[200]}
            title={
              <Box sx={{ px: 1, py: 2 }}>
                <IconGraphy
                  icon="Finance.AttachMoney"
                  color={colors.parisGreen[200]}
                  style={{ width: '20px', height: '20px' }}
                />
              </Box>
            }
            content={
              <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                <Typography variant="h4" style={{ fontWeight: '500', color: colors.purple[900] }}>
                  {Number(RGCoverage).toLocaleString()}
                </Typography>

                <Typography
                  variant="small"
                  style={{ fontWeight: '500', color: colors.neutral[900] }}
                >
                  Rent Guaranty
                </Typography>
              </Box>
            }
            onClick={handleRentGuarantyClick}
          />

          <ChartFooterChard
            backgroundColor="#F9F8F9"
            activeColor={colors.parisGreen[200]}
            title={
              <Box sx={{ px: 1, py: 2 }}>
                <IconGraphy
                  icon="Finance.AttachMoney"
                  color={colors.parisGreen[200]}
                  style={{ width: '20px', height: '20px' }}
                />
              </Box>
            }
            content={
              <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                <Typography variant="h4" style={{ fontWeight: '500', color: colors.purple[900] }}>
                  {Number(LDRCoverage).toLocaleString()}
                </Typography>

                <Typography
                  variant="small"
                  style={{ fontWeight: '500', color: colors.neutral[900] }}
                >
                  LDR Commercial
                </Typography>
              </Box>
            }
            onClick={handleLdrClick}
          />

          <ChartFooterChard
            backgroundColor="#F9F8F9"
            activeColor={colors.parisGreen[200]}
            title={
              <Box sx={{ px: 1, py: 2 }}>
                <IconGraphy
                  icon="Finance.AttachMoney"
                  color={colors.parisGreen[200]}
                  style={{ width: '20px', height: '20px' }}
                />
              </Box>
            }
            content={
              <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                <Typography variant="h4" style={{ fontWeight: '500', color: colors.purple[900] }}>
                  {Number(totalCoverage).toLocaleString()}
                </Typography>

                <Typography
                  variant="small"
                  style={{ fontWeight: '500', color: colors.neutral[900] }}
                >
                  Total Coverage
                </Typography>
              </Box>
            }
            onClick={handleTotalCoverageClick}
          />
        </Box>
      }
    />
  );
};
